import notifier from '@/notifier'
import api from '@/api'
import { isObject, transform } from 'lodash'

const omit = function (obj) {
  function omitFromObject (obj) {
    return transform(obj, function (result, value, key) {
      if (value === '' || value === undefined || value === null) {
        return
      }

      result[key] = isObject(value) ? omitFromObject(value) : value
    })
  }

  return omitFromObject(obj)
}

export default {
  namespaced: true,
  state: {
    sending: false,
    items: [],
    fetching: false
  },
  actions: {
    async add ({ state, commit, getters }, products) {
      commit('fetching')

      commit('setFetchData', products)
    },
    async send ({ state, commit, getters }, module) {
      for (var i in state.items) {
        let productAnnouncement = omit(state.items[i])

        if (productAnnouncement.status === 'sent') {
          continue
        }

        for (let j in productAnnouncement.variations) {
          const variation = productAnnouncement.variations[j]
          if (this.getters['errors/getErrorsBySku'](variation.sku)) {
            commit('setStatusVariationToFix', variation)
          }
        }

        if (this.getters['errors/getErrorsByProductId'](productAnnouncement.productId)) {
          commit('setStatusVariationToFix', productAnnouncement)
          continue
        }

        try {
          commit('setStatusVariationToSending', productAnnouncement)

          await api[module.identifier].saveProduct(productAnnouncement)

          commit('setStatusVariationToSent', productAnnouncement)
        } catch (error) {
          if (error.response.status === 422) {
            commit('setStatusVariationToError', productAnnouncement)
          } else if (error.response.status === 400 && error.response.data.message.indexOf('Validation failed') === -1) {
            notifier.error(error.response.data.message, 'Falha')
            return false
          } else if (error.response.status === 400 && error.response.data.message.indexOf('Validation failed') !== -1) {
            commit('addError', {
              product: productAnnouncement,
              errors: error.response.data.data
            })
            commit('setStatusVariationToFix', productAnnouncement)
          } else {
            commit('setStatusVariationToError', productAnnouncement)
          }
        }

        productAnnouncement.original.variations = [...productAnnouncement.original.variations]
      }

      let countToFix = 0
      for (var j in state.items) {
        const productAnnouncement = state.items[j]

        if (productAnnouncement.status === 'to-fix') {
          countToFix++
        }
      }

      if (countToFix === 0) {
        notifier.success('Alteração em lote finalizada!', 'Finalizado')

        return true
      } else {
        notifier.error('Falha na alteração em lote!', 'Falha')

        return false
      }
    },
    async update ({ state, commit, getters }, module) {
      for (var i in state.items) {
        let productAnnouncement = omit(state.items[i])

        if (productAnnouncement.status === 'sent') {
          continue
        }

        if (this.getters['errors/getErrors'](productAnnouncement.productId)) {
          commit('setStatusVariationToFix', productAnnouncement)
          continue
        }

        try {
          commit('setStatusVariationToSending', productAnnouncement)

          await api[module.identifier].updateProduct(productAnnouncement)

          commit('setStatusVariationToSent', productAnnouncement)
        } catch (error) {
          if (error.response.status === 422) {
            commit('setStatusVariationToError', productAnnouncement)
          } else if (error.response.status === 400 && error.response.data.message.indexOf('Validation failed') === -1) {
            notifier.error(error.response.data.message, 'Falha')
            return false
          } else if (error.response.status === 400 && error.response.data.message.indexOf('Validation failed') !== -1) {
            commit('addError', {
              product: productAnnouncement,
              errors: error.response.data.data
            })
            commit('setStatusVariationToFix', productAnnouncement)
          } else {
            commit('setStatusVariationToError', productAnnouncement)
          }
        }

        productAnnouncement.original.variations = [...productAnnouncement.original.variations]
      }

      let countToFix = 0
      for (var j in state.items) {
        const productAnnouncement = state.items[j]

        if (productAnnouncement.original.status === 'to-fix') {
          countToFix++
        }
      }

      if (countToFix === 0) {
        notifier.success('Alteração em lote finalizada!', 'Finalizado')

        return true
      } else {
        notifier.error('Falha na alteração em lote!', 'Falha')

        return false
      }
    },
    async clearSentItems ({ state, commit, getters }) {
      commit('setFetchData', [])
    }
  },
  getters: {
    getAllVariations: state => () => state.items,
    getItem: state => productId => state.items.find(item => item.productId === productId)
  },
  mutations: {
    setFetchData (state, items) {
      state.items = items
      state.fetching = false
    },
    setStatusVariationToSending (state, item) {
      for (var x in state.items) {
        let itemLoop = state.items[x]

        if (itemLoop.productId === item.productId && itemLoop.account.identifier === item.account.identifier && itemLoop.productIdentifier === item.productIdentifier) {
          itemLoop.original.status = 'sending'
          itemLoop.status = 'sending'
        }
      }
    },
    setStatusVariationToSent (state, item) {
      for (var x in state.items) {
        let itemLoop = state.items[x]

        if (itemLoop.productId === item.productId && itemLoop.account.identifier === item.account.identifier && itemLoop.productIdentifier === item.productIdentifier) {
          itemLoop.original.status = 'sent'
          itemLoop.status = 'sent'
        }
      }
    },
    setStatusVariationToFix (state, item) {
      for (var x in state.items) {
        let itemLoop = state.items[x]

        if (itemLoop.productId === item.productId && itemLoop.account.identifier === item.account.identifier && itemLoop.productIdentifier === item.productIdentifier) {
          itemLoop.original.status = 'to-fix'
          itemLoop.status = 'to-fix'
        }

        const variation = itemLoop.original.variations.find(variation => variation.sku === item.sku)
        if (variation !== undefined) {
          variation.status = 'to-fix'
        }
      }
    },
    setStatusVariationToError (state, item) {
      for (var x in state.items) {
        let itemLoop = state.items[x]

        if (itemLoop.productId === item.productId && itemLoop.account.identifier === item.account.identifier && itemLoop.productIdentifier === item.productIdentifier) {
          itemLoop.original.status = 'error'
          itemLoop.status = 'error'
        }
      }
    },
    addError (state, { product, errors }) {
      for (var i in errors) {
        const error = errors[i]

        const newError = {
          productId: product.original.productId,
          property: error.property,
          error: {
            message: error.constraint,
            value: error[error.constraint]
          }
        }

        if (error.property.indexOf('price') !== -1) {
          newError.sku = error.message
        }

        this._actions['errors/addError'][0](newError)
      }
    },
    fetching (state) {
      state.fetching = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/panel/sendAnnouncements.js